import React from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import BasePageView from '../../../views/siteBasePages/sharedComponents/BasePageView/BasePageView';
import ContactBlock from './components/ContactBlock';

const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  position: relative;
  margin: 20px auto 40px auto;
  padding: 0 20px;
`;

export function ContactsView() {
  const { t } = useTranslation();
  const contacts = useSelector((state) =>
    get(state.siteContent, ['data', 'contacts'], []),
  );

  return (
    <BasePageView title={t('event.contact')}>
      <Container>
        <div className="row">
          {contacts.map((contact) => (
            <div key={contact.email} className="col-xs-12 col-sm-6">
              <ContactBlock contact={contact} />
            </div>
          ))}
        </div>
      </Container>
    </BasePageView>
  );
}

export default ContactsView;
